(function () {
  try {
    if (window.__elbetApiHeaderInjectorInstalled) {
      return;
    }
    window.__elbetApiHeaderInjectorInstalled = true;

    var params = new URLSearchParams(window.location.search);
    var company = params.get('company');
    if (!company) {
      return;
    }
    window.__elbetCompany = company;

    if (typeof XMLHttpRequest !== 'undefined' && XMLHttpRequest.prototype) {
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        try {
          this.setRequestHeader('X-Company', company);
        } catch (e) {}
        return origSend.apply(this, arguments);
      };
    }

    if (typeof window.fetch === 'function') {
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        try {
          init = init || {};
          var existingHeaders = init.headers || (input && typeof input === 'object' && input.headers) || {};
          var headers;
          if (typeof Headers !== 'undefined' && existingHeaders instanceof Headers) {
            headers = existingHeaders;
            if (!headers.has('X-Company')) {
              headers.set('X-Company', company);
            }
          } else if (typeof Headers !== 'undefined') {
            headers = new Headers(existingHeaders);
            if (!headers.has('X-Company')) {
              headers.set('X-Company', company);
            }
          } else {
            headers = existingHeaders;
            headers['X-Company'] = company;
          }
          init.headers = headers;
        } catch (e) {}
        return origFetch.call(this, input, init);
      };
    }
  } catch (e) {
  }
})();



//////////////////
// WEBPACK FOOTER
// ./src/ui/js/api-header-injector.js
// module id = 39
// module chunks = 13